import fetch from 'auth/FetchInterceptor';
import { API_BASE_URL } from 'configs/AppConfig';

const BASE_URL = API_BASE_URL;

/**
 *
 * @param {*} params
 * @returns {Promise<FetchPropertyOwnerResponse>}
 */
export function requestPropertyOwnerList( params) {
  return fetch.get(`${BASE_URL}/api/app/property-owner`, {
    params: {limit: Number.MAX_SAFE_INTEGER}
  });
 
}


/**
 * 
 * @param {PropertyOwnerForm} data 
 * @returns 
 */
export function requestCreatePropertyOwner(data) {
  return fetch.post(`${BASE_URL}/api/app/property-owner`, data)
}

/**
 *
 * @param {PropertyOwnerForm} data
 * @returns
 */
export function requestUpdatePropertyOwner(data) {
  const body = { ...data }
  delete body["_id"]
  return fetch.put(`${BASE_URL}/api/app/property-owner/${data._id}`, body)
}

